<template>
  <section
    class="content"
    id="threeColumnBanner"
  >
    <section>
      <div class="dotd-wrapper">
        <div class="sec-title">
          <h4
            v-if="promotions &&promotions.length > 0"
            id="deal-day-head"
												data-test="threeColumnBannerHeading"
          >
            DEAL OF THE DAY
          </h4>
        </div>
        <div class="dotd-content row mx-auto">
          <!-- col- -->
          <div
            class="dealofday col-12"
            v-for="(promotion, index) in promotions.slice(0,4)"
            v-bind:key="promotion.url"
            :class="promotions.length < 4?'col-md-4':
                promotions.length === 4?'col-md-3':''"
          >
            <a
              href=""
              @click.prevent="promotionFunction(promotion)"
              :id="'deal-img-link-'+index"
														:data-test="'threeColumnBannerLink'+index"
            >
              <img
                alt="Deals of the day image"
                class="deal-img"
                v-lazy="promotion.image_url"
                :id="'deal-img'+index"
																:data-test="'threeColumnBannerImg'+index"
              >
            </a>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('promotions', ['getAllPromotions']),
		promotions () {
			return this.getAllPromotions.filter(promotion =>
				promotion.promotion_type.replace(/\s+/g, '').toLowerCase() === 'dealoftheday')
		}
	},
	methods: {
		promotionFunction (promotion) {
			// coming soon page added
			// this.$router.push('/coming-soon')

			this.$router.push({
				name: 'ProductListPromotion',
				path: '/promotional_product-list',
				query: {
					promotionId: promotion.promotion_id,
					display_text: promotion.promotion_id
				}
			})
		}
	}
}
</script>
